var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPausedStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5A6.5 6.5 0 1014.5 8 6.508 6.508 0 008 1.5zM7 10a.5.5 0 01-1 0V6a.5.5 0 111 0v4zm3 0a.5.5 0 01-1 0V6a.5.5 0 111 0v4z",
    fill: "#FF6B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPausedStatusIcon);
export default __webpack_public_path__ + "static/media/PausedStatusIcon.45ce5632c2aa0e542669118cecb2d306.svg";
export { ForwardRef as ReactComponent };